import React, {useEffect, useState} from "react";
import {Button} from "../../../components/My/Button";
import {apiGetTariffList} from "./Actions";


const GetTariffList = ({subject}) => {

    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);


    const getTariffList = () => {
        setLoading(true);
        apiGetTariffList(subject.id, (response)=>{
            setData(response)
            setLoading(false);
        }, (error)=>{
            setLoading(false);
        })
    }


    if(subject?.connections?.key !== 'ELVIS' && subject?.connections?.key !== 'ENIGOO' && subject?.connections?.key !== 'COMINFO') return null

    return(
        <>
            <Button onClick={getTariffList} text={"Načti tarify"} loading={loading}/>
            <Button color={"bg-red-500"} onClick={()=>setData(null)} text={"Smazat výsledek"}/>
            {data && <pre>{JSON.stringify(data, null, 2)}</pre>}
        </>
    )
}

export default GetTariffList
